import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "social-buttons" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label"]

import instagramIcon from '@/icons/instagramIcon.vue'
import facebookIcon from '@/icons/facebookIcon.vue'
import { computed } from 'vue'
import { trackClick } from '@/utils/analytics'


export default /*@__PURE__*/_defineComponent({
  __name: 'SocialButtons',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props

const style = computed(() => (props.color ? { backgroundColor: props.color } : {}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "social-button",
      style: _normalizeStyle(style.value),
      href: "https://www.facebook.com/profile.php?id=100074741143252",
      target: "_blank",
      "aria-label": _ctx.$t('home.social.facebookAriaLabel'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackClick)('facebook')))
    }, [
      _createVNode(facebookIcon, { class: "scale-110" })
    ], 12, _hoisted_2),
    _createElementVNode("a", {
      class: "social-button",
      style: _normalizeStyle(style.value),
      href: "https://www.instagram.com/socutnozobozdravstvo/?igsh=czA2ZWdsdHo2Z2g3&utm_source=qr",
      target: "_blank",
      "aria-label": _ctx.$t('home.social.instagramAriaLabel'),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(trackClick)('instagram')))
    }, [
      _createVNode(instagramIcon, { class: "scale-90" })
    ], 12, _hoisted_3)
  ]))
}
}

})